module.exports = __webpack_public_path__ + "img/waf-vps.fcecd73.svg";